import { useThemeDetection } from '../hooks/useThemeDetection';

/**
 * Applies the user's light/dark theme (stored choice, else the OS preference) to `data-theme`
 * for every route. Rendered once in `main.tsx` above `<Routes>` so the routes outside `<App>` —
 * `/login` and `/waitlist` — follow the theme too; `useDescopeTheme` reads the same attribute to
 * put the embedded Descope flow in the matching mode.
 */
const ThemeDetection = () => {
  useThemeDetection();
  return null;
};

export default ThemeDetection;
